import './devbx.webform.header.css';

BX.addCustomEvent("DevBxWebFormCreated", function(app) {
    app.component('devbx-webform-header', {
        props: ['formSettings', 'pages', 'activePage'],
        computed: {
            titleFormatted() {
                return this.$root.htmlFormatFields(BX.util.htmlspecialchars(this.formSettings.title));
            },

            descriptionFormatted() {
                return this.$root.htmlFormatFields(this.formSettings.description);
            },

            pageDescriptionFormatted() {
                if (this.activePage)
                    return this.$root.htmlFormatFields(this.activePage.config.pageDescription);

                return '';
            },

            progressPercent() {
                let idx = Object.values(this.pages).indexOf(this.activePage);

                if (!this.activePage || idx < 0)
                    return 0;

                if (idx === this.pageItems.length - 1)
                    return 100;

                return (100 / this.pageItems.length) * (idx + 1);
            },

            pageItems() {

                let result = [],
                    passed = true;

                Object.values(this.pages).forEach((page, index) => {

                    let title;

                    if (page.config.pageTitle) {
                        title = page.config.pageTitle;
                    } else {
                        title = this.$root.formatString(this.$Bitrix.Loc.getMessage('DEVBX_WEB_FORM_NAVIGATION_PAGE_TITLE'), '#NUM#', index + 1);
                    }

                    if (page.id == this.activePage.id)
                        passed = false;

                    result.push({
                        title: title,
                        page: page,
                        passed: passed,
                    });
                });

                return result;
            },

            cssClass()
            {
                let result = {};

                if (this.formSettings.headerCssClass.length)
                {
                    result[this.formSettings.headerCssClass] = true;
                }

                return result;
            },

        },
        template: `
    <div class="devbx-webform-header" :class="cssClass">
        <h1 v-if="!formSettings.titleHidden" v-html="titleFormatted"></h1>
        <div class="devbx-webform-description" v-if="descriptionFormatted.length" v-html="descriptionFormatted"></div>
        
            <div class="devbx-webform-page-steps"
                :class="{'devbx-webform-page-steps-no-title': !formSettings.showPageTitles}" 
                v-if="pageItems.length>1 && formSettings.progressBar == 'STEPS'">
                <ul>
                    <li v-for="(item, index) in pageItems" :class="{'devbx-webform-page-step-active': item.page.id == activePage.id}">
                        <a href @click.stop.prevent="$root.setPageNumber(index)"><span v-if="formSettings.showPageTitles">{{item.title}}</span></a>
                    </li>
                </ul>
            </div>
        
            <div class="devbx-webform-page-progress-bar" v-if="pageItems.length>1 && formSettings.progressBar == 'BAR'">
                <ul>
                    <li class="devbx-webform-progress-bar-line"></li>
                    <li class="devbx-webform-progress-bar-pos" :style="{'width': progressPercent+'%'}"></li>
                    <li v-for="(item, index) in pageItems" :style="{'width': (100/pageItems.length)+'%'}" :class="{
                    'devbx-webform-page-step-active': item.page.id == activePage.id && formSettings.showPageTitles,
                    'devbx-webform-page-step-passed': item.passed || (item.page.id == activePage.id && !formSettings.showPageTitles),
                    }">
                        <a href @click.stop.prevent="$root.setPageNumber(index)"><span v-if="formSettings.showPageTitles">{{item.title}}</span></a>
                    </li>
                </ul>
            </div>
            
            <div class="devbx-webform-description" v-if="pageDescriptionFormatted.length" v-html="pageDescriptionFormatted"></div>
        
    </div>
    `
    });
});